/** Mirrors backend `config/mfaMethods.js` for admin Settings + Profile UI. */

export const MFA_METHOD_DEFS = [
  {
    id: 'microsoft_authenticator',
    label: 'Microsoft Authenticator',
    category: 'authenticator',
    description: 'TOTP codes via Microsoft Authenticator',
  },
  {
    id: 'google_authenticator',
    label: 'Google Authenticator',
    category: 'authenticator',
    description: 'TOTP codes via Google Authenticator',
  },
  {
    id: 'authy',
    label: 'Twilio Authy',
    category: 'authenticator',
    description: 'TOTP codes via Authy',
  },
  {
    id: 'lastpass_authenticator',
    label: 'LastPass Authenticator',
    category: 'authenticator',
    description: 'TOTP codes via LastPass Authenticator',
  },
  {
    id: 'email_otp',
    label: 'Email OTP',
    category: 'otp',
    description: 'One-time password sent to your email address',
  },
  {
    id: 'sms',
    label: 'Cell phone text (SMS)',
    category: 'phone',
    description: 'One-time password sent by SMS to your mobile number',
  },
  {
    id: 'voice_call',
    label: 'Cell phone call',
    category: 'phone',
    description: 'One-time password delivered by automated voice call',
  },
];

export const DEFAULT_MFA_METHODS = [
  'microsoft_authenticator',
  'google_authenticator',
  'email_otp',
];

export function isAuthenticatorMethod(id) {
  return ['microsoft_authenticator', 'google_authenticator', 'authy', 'lastpass_authenticator'].includes(id);
}

export function mfaMethodLabel(id) {
  return MFA_METHOD_DEFS.find((m) => m.id === id)?.label || id;
}

/** Mirrors backend `auth.mfa_remember_userid_days` defaults. */
export const DEFAULT_REMEMBER_USERID_DAYS = 14;
export const MIN_REMEMBER_USERID_DAYS = 1;
export const MAX_REMEMBER_USERID_DAYS = 90;
export const MFA_REMEMBER_USERID_DAYS_KEY = 'auth.mfa_remember_userid_days';

export function normalizeRememberUseridDays(raw) {
  const n = parseInt(String(raw ?? ''), 10);
  if (!Number.isFinite(n)) return DEFAULT_REMEMBER_USERID_DAYS;
  return Math.min(MAX_REMEMBER_USERID_DAYS, Math.max(MIN_REMEMBER_USERID_DAYS, n));
}
